import { cn } from "@/lib/utils"

interface RivetsProps {
  corners?: "2" | "4"
}

const rivetClass = "absolute w-1.5 h-1.5 rounded-full z-[1]"
// Flat inked circle: solid fill, a hard-edged highlight dot, and a heavy black
// outline — not a simulated 3D sphere (see design-language: "Flat, not spherical").
const rivetStyle: React.CSSProperties = {
  background:
    "radial-gradient(circle at 34% 34%, oklch(0.55 0.01 240) 0 22%, oklch(0.24 0.01 240) 24%)",
  boxShadow: "0 0 0 1px oklch(0.08 0 0 / 0.9)",
}

export function Rivets({ corners = "4" }: RivetsProps) {
  return (
    <>
      <span className={cn(rivetClass, "top-1.5 left-1.5")} style={rivetStyle} />
      <span
        className={cn(rivetClass, "top-1.5 right-1.5")}
        style={rivetStyle}
      />
      {corners === "4" && (
        <>
          <span
            className={cn(rivetClass, "bottom-1.5 left-1.5")}
            style={rivetStyle}
          />
          <span
            className={cn(rivetClass, "right-1.5 bottom-1.5")}
            style={rivetStyle}
          />
        </>
      )}
    </>
  )
}
